// Validate Gmail address
export const isValidGmail = (email) => {
    return email.endsWith('@gmail.com') && email.indexOf('@') > 0;
};

// Extract user ID from email (everything before @)
export const getUserIdFromEmail = (email) => {
    if (!email) return "";
    return email.split('@')[0];
};

// Format date as dd/mm/yyyy
export const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('vi-VN', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    });
};

// Get role display name based on role ID
export const getRoleDisplay = (roleId, roles) => {
    const role = roles.find(r => r.id === roleId);
    return role ? role.name : roleId;
};

// Get role color based on role ID
export const getRoleColor = (roleId) => {
    // Define colors for different roles
    const roleColors = {
        'root': '#e91e63',      // Pink
        'admin': '#2196f3',     // Blue
        'content': '#4caf50',   // Green
        'package': '#ff9800'    // Orange
    };
    
    return roleColors[roleId] || '#9e9e9e'; // Default gray
};